import { useHistory } from 'react-router-dom';

const useEdit = () => {
  const history = useHistory();

  const sendToEditCourse = course => {
    history.push({
      pathname: '/cursos/editar',
      state: {
        update: true,
        course,
        isComingFrom: '/cursos',
      },
    });
  };

  return {
    sendToEditCourse,
  };
};

export default useEdit;
